import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { scrollToId as scrollTo } from "@/lib/scroll";
import { getSettings } from "@/lib/api";

const NAV = [
  ["Leistungen", "#leistungen"],
  ["Preise", "#preise"],
  ["Ablauf", "#ablauf"],
  ["Änderungen", "#aenderungen"],
  ["FAQ", "#faq"],
  ["Kontakt", "#kontakt"],
];

const DEFAULT_CONTACT = { email: "saba@saba-business-development.de", phone: "+49 157 50186769" };

export default function Footer() {
  const [contact, setContact] = useState(DEFAULT_CONTACT);
  useEffect(() => {
    getSettings()
      .then((s) => setContact({ email: s?.contact_email || DEFAULT_CONTACT.email, phone: s?.contact_phone || DEFAULT_CONTACT.phone }))
      .catch(() => {});
  }, []);

  return (
    <footer className="relative bg-[#0a0705] border-t border-white/10 pt-20" data-testid="footer">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid lg:grid-cols-[1.2fr_1fr] gap-12 pb-16">
          <div>
            <p className="font-tech text-xs uppercase tracking-[0.25em] text-[#FF3B00] mb-4">Landingsstrategie</p>
            <p className="font-display text-3xl md:text-4xl text-white leading-tight max-w-xl">
              Ihr professioneller Webauftritt als monatlicher Service.
            </p>
            <p className="mt-4 text-neutral-400 max-w-md">
              Website, Domain, Hosting und Betreuung – alles aus einer Hand. Ohne hohe Anfangsinvestition.
            </p>
            <button
              onClick={() => scrollTo("#kontakt")}
              className="mt-8 group inline-flex items-center gap-2 bg-[#FF3B00] text-white font-tech text-sm uppercase tracking-[0.12em] px-7 py-4 hover:bg-[#FF5C2B] active:scale-95 transition-all duration-200"
              data-testid="footer-cta"
            >
              Website anfragen
              <ArrowUpRight size={18} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </button>
          </div>

          <div className="grid grid-cols-2 gap-8">
            <div>
              <p className="font-tech text-xs uppercase tracking-[0.18em] text-neutral-500 mb-5">Navigation</p>
              <ul className="space-y-3">
                {NAV.map(([label, href]) => (
                  <li key={href}>
                    <button onClick={() => scrollTo(href)} className="text-neutral-300 hover:text-[#FF3B00] transition-colors">
                      {label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="font-tech text-xs uppercase tracking-[0.18em] text-neutral-500 mb-5">Kontakt</p>
              <ul className="space-y-3 text-neutral-300">
                <li><a href={`mailto:${contact.email}`} className="hover:text-[#FF3B00] transition-colors break-all">{contact.email}</a></li>
                <li><a href={`tel:${contact.phone.replace(/\s/g, "")}`} className="hover:text-[#FF3B00] transition-colors">{contact.phone}</a></li>
                <li className="text-neutral-500">Danziger Str. 18 · 74889 Sinsheim</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="overflow-hidden border-t border-white/10">
          <p className="font-display text-[13vw] lg:text-[11vw] leading-[0.8] tracking-tighter text-transparent select-none py-4 whitespace-nowrap"
             style={{ WebkitTextStroke: "1px rgba(244,244,240,0.08)" }}>
            Landingsstrategie.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 py-8 border-t border-white/10 text-neutral-600 font-tech text-xs uppercase tracking-[0.14em]">
          <p>© {new Date().getFullYear()} Landingsstrategie · Saba Business Development</p>
          <div className="flex items-center gap-6">
            <Link to="/impressum" className="hover:text-neutral-300 transition-colors" data-testid="footer-impressum">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-neutral-300 transition-colors" data-testid="footer-datenschutz">Datenschutz</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
